// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"e237c99a","455":"e7a5f088","488":"c87f4eb3","839":"8786cc14","977":"b5df481d"}[chunkId] + ".chunk.js";
};